import { createGetAPI, createPostAPI } from '@cuemath/rest-api';
import { BASE_URL } from 'constants/api';

const EVAL_SPECIALIST_REASSIGN_URL = studentServiceId =>
  `${BASE_URL}/students/${studentServiceId}/eval-specialist-reassign`;

// --- Free alternates at the booked slot (least-loaded first, so [0] is the auto-pick) ---

const { useGet: useGetEvalSpecialistAlternates } = createGetAPI({
  // assessmentId is optional — omitted, the backend resolves the student's latest DEMO_V2 booking.
  getURL: (studentServiceId, query = {}) => {
    const { assessmentId } = query;
    const baseURL = `${EVAL_SPECIALIST_REASSIGN_URL(studentServiceId)}/alternates/`;
    return assessmentId ? `${baseURL}?assessment_id=${assessmentId}` : baseURL;
  },
});

// --- Reassign (omit new_teacher_id to let the system auto-pick) ---

const { usePost: usePostEvalSpecialistReassign } = createPostAPI({
  getURL: (_, studentServiceId) => `${EVAL_SPECIALIST_REASSIGN_URL(studentServiceId)}/`,
});

export { useGetEvalSpecialistAlternates, usePostEvalSpecialistReassign };
